import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../services/content.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  showSideMenu: boolean = false;
  menuItems = null;
  headerLogo = null;
  headerExtraLogo = null;
 
  constructor(private contentService: ContentService) { }

  ngOnInit(): void {
    this.headerLogo = this.contentService.getHeaderLogo();
    this.headerExtraLogo = this.contentService.getHeaderExtraLogo();
    this.menuItems = this.contentService.getMenuItems();
  }

  toggleMenu() {
    if(this.showSideMenu == false) {
      this.showSideMenu = true;
    }
    else {
      this.showSideMenu = false;
    }
  }

}
